import i18n from "i18n";

export const integrationsMessages = {
  create: i18n.t('notifications.integrations.create'),
  update: i18n.t('notifications.integrations.update'),
  delete: i18n.t('notifications.integrations.delete')
};
